<template>
  <search-picker :input-id="inputId" @selected="selected" :current="current" :placeholder="placeholder" :full-width="fullWidth" :with-icon="withIcon" :with-popper="withPopper" :get-data="getTags" :can-add="canAdd">
    <template v-slot:list-item-content="{ option }">
      <div
        v-if="option.ancestors && option.ancestors.length"
        class="search-picker__subtext">
          <span v-for="(ancestor, ancestorIndex) in option.ancestors" :key="`name-${option.id}-${ancestor.id}`">
            {{ ancestorIndex > 0 ? ' > ' : '' }}{{ ancestor.name }}
          </span>
      </div>
    </template>
  </search-picker>
</template>

<script>
import { http } from 'utils'
import SearchPicker from './SearchPicker'

export default {
  components: { SearchPicker },

  props: {
    current: {
      type: Array,
      required: true
    },

    canAdd: {
      type: Boolean,
      default: true
    },

    placeholder: {
      type: String,
      default: ''
    },

    fullWidth: {
      type: Boolean,
      default: false
    },

    withIcon: {
      type: Boolean,
      default: false
    },

    withPopper: {
      type: Boolean,
      default: true
    },

    parentNode: {
      type: Number,
      default: null
    },

    maximum: {
      type: Number,
      default: null
    },

    inputId: {
      type: String,
      default: null
    },

    defaultFetch: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    selected (option) {
      option.current = true
      this.$emit('selected', option)
    },

    async getTags (params) {
      if (this.defaultFetch && !params.search) {
        const response = await http.get('tag-nodes/top-level', { params })
        return response.data.data
      }
      if (this.parentNode) {
        params.parent_node = this.parentNode
      }
      if (this.maximum) {
        params.per_page = this.maximum
      }
      const response = await http.get('tag-nodes', { params })
      return response.data.data
    }
  }
}
</script>
